module.exports = "/_next/static/images/license-female-dd5e10f97db5b24be37c224e9fdc60dc.png";